import {
	useDeleteVideoMutation,
	useGetVideosQuery,
} from "../../../features/video/videoApi";
import { Link } from "react-router-dom";
import { shortStr } from "../../../utils/commonUtility";
import Loading from "../../../components/ui/Loading";
import Error from "../../../components/ui/Error";
import EmptyResult from "../../../components/ui/EmptyResult";
import Table from "../../ui/Table";
import TableRow from "../../ui/TableRow";
import MessageToast from "../../ui/MessageToast";

export default function Videos() {
	const {
		data: videos,
		isLoading: isGetVideosLoading,
		isError: isGetVideosError,
	} = useGetVideosQuery() || {};

	const [
		deleteVideo,
		{ isError: isDeleteVideoError, isSuccess: isDeleteVideoSuccess },
	] = useDeleteVideoMutation() || [];

	const handleVideoDelete = (videoId) => {
		deleteVideo(videoId);
	};

	// Decide what to render
	let content = null;
	if (isGetVideosLoading) {
		content = <Loading />;
	} else if (!isGetVideosLoading && isGetVideosError) {
		content = <Error message="There was an error getting the videos!" />;
	} else if (
		!isGetVideosLoading &&
		!isGetVideosError &&
		videos?.length === 0
	) {
		content = <EmptyResult message="No videos available, please add" />;
	} else if (!isGetVideosLoading && !isGetVideosError && videos?.length > 0) {
		const headers = ["Video Title", "Description", "Action"];
		content = (
			<Table headers={headers}>
				{videos.map((video) => {
					const shortTitle = shortStr(video.title, 50);
					const shortDescription = shortStr(video.description, 80);

					return (
						<TableRow
							key={video.id}
							data={[shortTitle, shortDescription]}
							editRoute={`/admin/videos/edit/${video.id}`}
							deleteCallBack={handleVideoDelete}
							dataId={video.id}
						/>
					);
				})}
			</Table>
		);
	}

	return (
		<section className="py-6 bg-primary">
			<div className="mx-auto max-w-full px-5 lg:px-20">
				<div className="px-3 py-20 bg-opacity-10">
					<div className="w-full flex">
						<Link to="/admin/videos/add" className="btn ml-auto">
							Add Video
						</Link>
					</div>
					{content}
				</div>
			</div>

			{isDeleteVideoSuccess && (
				<MessageToast message="Video delete successful" />
			)}
			{isDeleteVideoError && (
				<MessageToast
					message="There was an error deleting video"
					type="error"
					delay={3000}
				/>
			)}
		</section>
	);
}
